import createDocumentResource from 'src/actions/shared/createDocumentResource';

type AnswerLanguage = Array<string>;

const answerLanguagesResource = createDocumentResource<AnswerLanguage>({
  name: 'answerLanguages',
  endpoint: 'v1/orgs/:orgId/configuration/languages',
  initialValue: [],
  reducers: {
    updateSuccess: state => {
      // By default document resources don't navigate back after update successes - but since
      // we're treating the languages document like a collection, we need to navigate back to
      // close the modal after success.
      setImmediate(() => window.history.back());
      state.persistingState = 'succeeded';
    },
  },
});

export default answerLanguagesResource;
